
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function HomePage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [freeSearches] = useState(3);

  const recentSearches = [
    { plateNumber: 'أ ب ج 1234', result: 'تم العثور', date: '2024-01-15' },
    { plateNumber: 'د هـ و 5678', result: 'لا توجد نتيجة', date: '2024-01-14' },
    { plateNumber: 'ز ح ط 9012', result: 'تم العثور', date: '2024-01-13' }
  ];

  const handleSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/search?plate=${encodeURIComponent(searchQuery)}`);
    }
  };

  const handleCameraSearch = () => {
    navigate('/camera');
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20 font-cairo">
      {/* Header */}
      <div className="bg-gradient-to-l from-purple-600 to-pink-600 px-6 pt-12 pb-8">
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={() => navigate('/profile')}
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center"
          >
            <i className="ri-user-line text-white text-lg"></i>
          </button>
          <div className="text-right">
            <h1 className="text-white text-xl font-bold font-pacifico">
              سامي عبدالسلام
            </h1>
            <p className="text-purple-100 text-sm">
              البحثات المجانية المتبقية: {freeSearches}
            </p>
          </div>
        </div>

        {/* Search Bar */}
        <div className="relative">
          <Input
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="ابحث برقم اللوحة"
            className="bg-white border-none text-gray-900 pl-12 text-right"
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
          />
          <button
            onClick={handleSearch}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>
      </div>

      {/* Main Actions */}
      <div className="px-6 -mt-4">
        <div className="grid grid-cols-1 gap-4">
          {/* Camera Scan */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center mb-4">
              <div className="flex-1 text-right">
                <h3 className="font-semibold text-gray-900">التقاط لوحة السيارة</h3>
                <p className="text-gray-600 text-sm">استخدم الكاميرا لمسح اللوحة تلقائياً</p>
              </div>
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center ml-4">
                <i className="ri-camera-line text-purple-600 text-xl"></i>
              </div>
            </div>
            <Button
              onClick={handleCameraSearch}
              className="w-full"
              icon={<i className="ri-camera-line w-4 h-4"></i>}
            >
              تفعيل الكاميرا
            </Button>
          </div>

          {/* Manual Entry */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center mb-4">
              <div className="flex-1 text-right">
                <h3 className="font-semibold text-gray-900">إدخال رقم اللوحة يدوياً</h3>
                <p className="text-gray-600 text-sm">اكتب رقم اللوحة للبحث المباشر</p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center ml-4">
                <i className="ri-edit-line text-green-600 text-xl"></i>
              </div>
            </div>
            <Button
              onClick={() => navigate('/search')}
              variant="outline"
              className="w-full"
              icon={<i className="ri-edit-line w-4 h-4"></i>}
            >
              البحث اليدوي
            </Button>
          </div>
        </div>
      </div>

      {/* Recent Searches */}
      {recentSearches.length > 0 && (
        <div className="px-6 mt-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4 text-right">اخر السجلات</h2>
          <div className="space-y-3">
            {recentSearches.map((search, index) => (
              <div key={index} className="bg-white rounded-lg p-4 shadow-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3 space-x-reverse">
                    <button
                      onClick={() =>
                        navigate(
                          `/search?plate=${encodeURIComponent(search.plateNumber)}`
                        )
                      }
                      className="text-purple-600 hover:text-purple-800"
                    >
                      <i className="ri-arrow-left-line text-lg"></i>
                    </button>
                  </div>
                  <div className="flex-1 text-right mr-4">
                    <div className="flex items-center justify-between mb-2">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-medium ${
                          search.result === 'تم العثور'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                        }`}
                      >
                        {search.result}
                      </span>
                      <p className="font-medium text-gray-900 text-lg">{search.plateNumber}</p>
                    </div>
                    <p className="text-sm text-gray-500">{search.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Upgrade Banner */}
      <div className="px-6 mt-8">
        <div className="bg-gradient-to-l from-purple-600 to-pink-600 rounded-xl p-6 text-white">
          <div className="flex items-center justify-between gap-4">
            <button
              onClick={() => navigate('/payment')}
              className="bg-white text-purple-600 hover:bg-purple-50 px-6 py-3 rounded-lg font-medium text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-purple-600 whitespace-nowrap"
            >
              ترقية
            </button>
            <div className="flex-1 text-right mr-4">
              <h3 className="font-semibold mb-2">ترقية حسابك</h3>
              <p className="text-purple-100 text-sm">احصل على بحثات غير محدودة</p>
            </div>
          </div>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
